import { FC } from 'react';
import styled from 'styled-components';
import useTheme from '../../utils/useTheme';
import { Icon } from '../Icon/Icon';
import { Image } from '../Image/Image';

const AvatarElement = styled.span<Pick<IProps, 'color' | 'size' | 'bg'>>`
  color: ${props => props.color};
  background-color: ${props => props.bg};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: ${props => getSize(props.size)}px;
  height: ${props => getSize(props.size)}px;
  flex-shrink: 0;
`;

export type AvatarSize = 'small' | 'medium' | 'large' | 'extra-large';
export type IconSize = 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large';

export interface IProps {
  /** Background color of avatar  */
  bg?: string;
  /** Primary color of icon */
  color?: string;
  /** Size of avatar circle. One of "small" | "medium" (default) | "large" | "extra-large" */
  size?: AvatarSize;
  /** Size of icon. One of  "extra-small" | "small" | "medium" (default) | "large" | "extra-large" */
  iconSize?: IconSize;
  /** FontAwesome icon name */
  icon?: string;
  /** Image URL used to render an avatar image */
  image?: string;
}

export const Avatar: FC<IProps> = ({ image, size, bg, color = '#fff', icon = 'question', iconSize }) => {
  const theme = useTheme();

  if (image) {
    return <Image src={image} size={getSize(size)} circular={true} />;
  } else {
    const background = bg ? bg : theme.vars.newColor.darkGS2;

    return (
      <AvatarElement size={size} color={color} bg={background} data-testid="Avatar">
        <Icon icon={icon} size={iconSize || 'medium'} />
      </AvatarElement>
    );
  }
};

function getSize(size: string) {
  switch (size) {
    case 'small':
      return 24;
    default:
    case 'medium':
      return 32;
    case 'large':
      return 40;
    case 'extra-large':
      return 50;
  }
}
